import { MM } from '../constants/machine-state/units';
export const inchesToUnits = (num, units) => num*(units === MM ? 25.4 : 1);
export const unitsToInches = (num, units) => num*(units === MM ? 1./25.4 : 1);
